// Page shell for content pages. TopLeft gives every page a scroll area exactly the size of the
// window under the navbar; a page using PAGE_SX fills that area (header on top, a child with
// flex: 1 takes the rest), so the page only scrolls when its content really doesn't fit.
// Replaces the old fixed heights like "calc(100vh - 180px)", which never matched the real
// header + margins and left a needless page scrollbar.
export const PAGE_SX = {
  height: '100%',
  boxSizing: 'border-box',
  p: '1.5rem',
  display: 'flex',
  flexDirection: 'column',
};

// Same, but only fills the window on wide screens; narrow screens stack cards and scroll
export const pageSxFor = (wide) => ({
  ...PAGE_SX,
  height: wide ? '100%' : 'auto',
});
